import { ErrorBoundary } from '@sentry/react'

import { env } from '../env'

if (env.NODE_ENV !== 'development') {
  import('./sentry')
}

export { ErrorBoundary }
export const captureException = import('@sentry/react').then((mod) => mod.captureException)
export const captureMessage = import('@sentry/react').then((mod) => mod.captureMessage)
